
import { SearchBaseModel } from '../commonModels';
import { DateRange } from '../commonModels';

export class SaleArticleSearchModel extends SearchBaseModel {

  public RegistrationNumber: string;
  public CustomerId: number;
  public GarageId: number;
  public CustomerName: string;
  public ArticleName: string;
  public DateRange: DateRange;
  public Period: any;
  public IsInvoiceIssued: boolean;
  public IsSupplierOnly: boolean;
  public GarageName: string;
  public GarageInvoiceNumber: string;
  public InvoiceNumber: string;
  public IsCustomerInvoice: boolean;
  public IsGarageInvoice: boolean;

  constructor() {
    super();
    this.RegistrationNumber = null;
    this.CustomerId = null;
    this.CustomerName = null;
    this.ArticleName = null;
    this.DateRange = new DateRange();
    this.IsInvoiceIssued = null;
    this.InvoiceNumber = null;
    this.IsSupplierOnly = null;
    this.GarageInvoiceNumber = null;
    this.Period = null;
    this.IsCustomerInvoice = null;
    this.IsGarageInvoice = null;
    }

}




